import { createContext, useContext, useState } from 'react'

import { useAuth } from 'hooks/useAuth'

import { clearAppCaches } from 'utils/auxiliaries/delete-cache'

const UserContext = createContext()

export const UserProvider = ({ children }) => {
  const [authEnabled, setAuthEnabled] = useState(() => {
    return localStorage.getItem('hasSession') === '1'
  })

  const userQuery = useAuth({ enabled: authEnabled })

  const logout = async () => {
    localStorage.removeItem('hasSession')
    setAuthEnabled(false)
    userQuery.remove()
    await clearAppCaches()
  }

  const enableAuth = () => {
    localStorage.setItem('hasSession', '1')
    setAuthEnabled(true)
    userQuery.refetch()
  }

  return (
    <UserContext.Provider
      value={{
        ...userQuery,
        user: userQuery.data,
        isAuthenticated: !!userQuery.data,
        logout,
        enableAuth,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUser = () => useContext(UserContext)
